export const safeLocalStorage = {
  setItem(key: string, val: string) {
    try {
      return localStorage.setItem(key, val);
    } catch (e) {
      console.warn(`localStorage.setItem failed ${e}`);
      return null;
    }
  },

  getItem(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn(`localStorage.getItem failed ${e}`);
      return null;
    }
  },

  removeItem(key: string) {
    try {
      return localStorage.removeItem(key);
    } catch (e) {
      console.warn(`localStorage.removeItem failed ${e}`);
      return null;
    }
  },

  clear() {
    try {
      return localStorage.clear();
    } catch (e) {
      console.warn(`localStorage.clear failed ${e}`);
      return null;
    }
  },

  key(k: number) {
    try {
      return localStorage.key(k);
    } catch (e) {
      console.warn(`localStorage.key failed ${e}`);
      return null;
    }
  },
};
